import React from "react";
import PdfViewer from "../../PdfViewer";

const EntregaServicioClienteRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-entrega-de-servicios-a-cliente-RACI.pdf`;
  /*const pdfUrl = "/pdf/06-entrega-de-servicios-a-cliente-RACI.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Entrega de Servicio a Cliente Matriz RACI</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default EntregaServicioClienteRACI;
